<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1IiQVC/tc-custom/9781504056960.jpg?1702846315449" alt="This image is the cover for the book Executioner Series Books 4–6, The Executioner"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Executioner Series Books 4–6, The Executioner
      </h1>
      <p class="bookDescription body article font2">
        <b>Bad news for bad guys: “Action adventure icon” Mack Bolan is back—as the million-selling series continues (<i>Los Angeles Times</i>).</b><br/>  <br/> To avenge his father, former Special Forces sniper Mack Bolan declares a one-man war on the Mafia. Included in this volume are books 4–6 in the long-running series.<br/>  <br/><i>Miami Massacre</i>: A Miami summit attended by every mob capo in the country offers the Executioner the perfect opportunity to destroy the Mafia in one fell swoop.<br/>  <br/><i>Continental Contract</i>: Forced to flee to France, Bolan takes on the thugs of the Paris underworld, foiling the kidnapping of a movie star and rescuing some frisky <i>filles de joie</i> from sex slave traders.<br/>  <br/><i>Assault on Soho</i>: The Executioner takes his war to the streets of London, where he’s about to turn merry old England into bloody hell.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Don Pendleton
      </h2>
      
      <p class="authorDescription body article">Don Pendleton (1927&ndash;1995) was born in Little Rock, Arkansas. He served in the US Navy during World War II and the Korean War. His first short story was published in 1957, but it was not until 1967, at the age of forty, that he left his career as an aerospace engineer and turned to writing full time.&#160;After producing a number of science fiction and mystery novels, in 1969 Pendleton launched his first book in the Executioner saga:&#160;<I>War Against the Mafia</I>.&#160;The series, starring Vietnam veteran Mack Bolan, was so successful that it inspired a new American literary genre, and Pendleton became known as the father of action-adventure.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2a20bf84